import { Controller } from "@hotwired/stimulus"
import moment from "moment"

export default class extends Controller {
  static values = {
    format: String,
    hourFormat: String,
    rangeProfile: String,
    timePickers: Boolean,
    hidePresets: Boolean,
    minDate: String,
    rangeLabel: String,
    calendarCount: Number,
    singleDate: Boolean
  }

  connect() {
    const format = this.hasFormatValue ? this.formatValue : ""
    const opts = {
      format,

      onbeforeshow: (calentim) => {
        this.range = this.element.value
      },

      onafterhide: (calentim) => {
        if (this.range === this.element.value) {
          return
        }

        calentim.fetchInputs()

        const { startDate, endDate } = calentim.config
        const event = new CustomEvent("components.calentime.changed", {
          detail: { element: this.element, startDate, endDate }
        })

        window.dispatchEvent(event)
      }
    }

    if (this.hasHourFormatValue) {
      opts.hourFormat = this.hourFormatValue
    }

    if (this.hasRangeProfileValue) {
      opts.ranges = this.customRanges()
    }

    if (this.hasTimePickersValue) {
      opts.showTimePickers = this.timePickersValue
    }

    if (this.hasRangeLabelValue) {
      opts.rangeLabel = this.rangeLabelValue
      opts.rangeIcon = ""
    }

    if (this.hasHidePresetsValue) {
      opts.showFooter = !this.hidePresetsValue
    }

    if (this.hasMinDateValue) {
      opts.minDate = this.minDateValue
    }

    if (this.hasCalendarCountValue) {
      opts.calendarCount = this.calendarCountValue
    }

    if (this.hasSingleDateValue) {
      opts.singleDate = this.singleDateValue
    }

    $(this.element).calentim(opts)
  }

  customRanges() {
    if (this.rangeProfileValue === "monthly") {
      return [
        {
          title: "Last 2 months",
          startDate: moment().utcOffset(huntressData.tzOffset).subtract(2, "months"),
          endDate: moment().utcOffset(huntressData.tzOffset),
        }, {
          title: "Last 3 months",
          startDate: moment().utcOffset(huntressData.tzOffset).subtract(3, "months"),
          endDate: moment().utcOffset(huntressData.tzOffset),
        }, {
          title: "Last 6 months",
          startDate: moment().utcOffset(huntressData.tzOffset).subtract(6, "months"),
          endDate: moment().utcOffset(huntressData.tzOffset)
        }
      ]
    } else if (this.rangeProfileValue === "hourly") {
      return [
        {
          title: "Last 10 minutes",
          startDate: moment().utcOffset(huntressData.tzOffset).subtract(10, "minutes"),
          endDate: moment().utcOffset(huntressData.tzOffset),
        }, {
          title: "Last 30 minutes",
          startDate: moment().utcOffset(huntressData.tzOffset).subtract(30, "minutes"),
          endDate: moment().utcOffset(huntressData.tzOffset),
        }, {
          title: "Last hour",
          startDate: moment().utcOffset(huntressData.tzOffset).subtract(1, "hours"),
          endDate: moment().utcOffset(huntressData.tzOffset),
        }, {
          title: "Last 6 hours",
          startDate: moment().utcOffset(huntressData.tzOffset).subtract(6, "hours"),
          endDate: moment().utcOffset(huntressData.tzOffset),
        }, {
          title: "Last day",
          startDate: moment().utcOffset(huntressData.tzOffset).subtract(1, "days"),
          endDate: moment().utcOffset(huntressData.tzOffset)
        },
      ]
    } else if (this.rangeProfileValue === "minutes_to_month") {
      return [
        {
          title: "15 mins",
          startDate: moment().utcOffset(huntressData.tzOffset).subtract(15, "minutes"),
          endDate: moment().utcOffset(huntressData.tzOffset),
        }, {
          title: "30 mins",
          startDate: moment().utcOffset(huntressData.tzOffset).subtract(30, "minutes"),
          endDate: moment().utcOffset(huntressData.tzOffset),
        }, {
          title: "1 hour",
          startDate: moment().utcOffset(huntressData.tzOffset).subtract(1, "hours"),
          endDate: moment().utcOffset(huntressData.tzOffset),
        }, {
          title: "1 day",
          startDate: moment().utcOffset(huntressData.tzOffset).subtract(1, "days"),
          endDate: moment().utcOffset(huntressData.tzOffset),
        }, {
          title: "7 days",
          startDate: moment().utcOffset(huntressData.tzOffset).subtract(7, "days"),
          endDate: moment().utcOffset(huntressData.tzOffset)
        },{
          title: "30 days",
          startDate: moment().utcOffset(huntressData.tzOffset).subtract(30, "days"),
          endDate: moment().utcOffset(huntressData.tzOffset)
        }
      ]
    } else {
      throw new Error(`unknown range profile value: ${this.rangeProfileValue}`)
    }
  }
}
